import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Header } from '@/components/Settings/DataExtraction/ExtractionType/Hierarchy/Steps/Header';
import { StepsContainer } from '../../../styles';
import { Tooltip } from '@/components/ui/Tooltip';
import { Tools } from '../Form';
import { useDataExtractionReport } from '@/context/DataExtractionReport';

const tooltipContent = (
	<Tooltip content={I18n.get('The tools listing shows the number of reviews available in each category.')} />
);

export function ToolsSection() {
	const { gutterLayout } = useDataExtractionReport();
	return (
		<StepsContainer>
			<Row gutter={gutterLayout} justify="space-between">
				<Col span={20}>
					<Header
						title={I18n.get('Tools')}
						description={I18n.get(
							'Select one or more tools for extraction. If desired, you can proceed without including tools in the extraction.'
						)}
						tooltip={tooltipContent}
					/>
				</Col>
				<Col span={24}>
					<Tools />
				</Col>
			</Row>
		</StepsContainer>
	);
}
